import { useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { IDeleteHostGroupResponse, DELETE_HOST_GROUP } from 'schemas';
import notification from 'services/notificationService';

import { TDeleteHostGroup } from './interfaces';

export const useDeleteHostGroup = (
  t: TTranslator<TLocalesKeys>
): TDeleteHostGroup => {
  const [deleteHostGroup] = useMutation<IDeleteHostGroupResponse>(
    DELETE_HOST_GROUP,
    {
      update: (cache, { data }) => {
        const group = data?.deleteHostGroup;

        if (!group) return;

        cache.evict({
          id: cache.identify({ ...group, __typename: 'HostGroupOverview' }),
        });
        cache.gc();
      },
      onCompleted: ({ deleteHostGroup: { title } }) =>
        notification.info({
          t,
          leftDescription: title,
          title: t('group.deleted'),
          type: 'success',
          dismiss: 5,
        }),
    }
  );

  return deleteHostGroup;
};
